// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserSubjectView, UserSubjectViewSchema } from 'api/gen/UserSubjectView';

const requiredPart = t.interface({
  content: t.union([t.array(UserSubjectViewSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserSubjectViewSchema = excess(requiredPart);

export interface PagedModelUserSubjectView extends t.TypeOf<typeof PagedModelUserSubjectViewSchema> {}
